import { Link } from "react-router-dom";
import { ROUTES } from "~/const";
import { userStore } from "~/stores/user";

import "./style.less";
import { trans } from "~/utils/trans";

export default function FillProfileInfo() {
	const userData = userStore(userState => userState.user);

	return userData.email && userData.errors.length > 0
		? <div className="fillProfileInfo">
			{trans("fillProfile.before")}<Link to={ROUTES.profile}>{trans("fillProfile.link")}</Link>{trans("fillProfile.after")} <strong>{userData.errors.map(field => trans(`notifications.profile.fields.${field}`)).join(", ")}</strong>
		</div>
		: null;
}
